export default __webpack_public_path__ + "static/media/home.7dc2a865.PNG";